import isChromatic from 'chromatic/isChromatic';

const ignoreInChromatic = () =>
  isChromatic() ? { 'data-chromatic': 'ignore' } : {};

export default ignoreInChromatic;
